import { Route, Routes } from 'react-router-dom';
import NotFound from '../screens/Auth/NotFound';
import LearningPackageReferralTier1Screen from '../screens/Referral/LearningPackageReferralTier1';
import LearningPackageReferralTier2Screen from '../screens/Referral/LearningPackageReferralTier2';

const ReferralsRoute: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<LearningPackageReferralTier1Screen />} />
      <Route path="/:id" element={<LearningPackageReferralTier2Screen />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default ReferralsRoute;
